export function isElementFocusable(element: HTMLElement) {
    if (
        element.tabIndex > 0 ||
        (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)
    ) {
        return true;
    }

    if (
        !element.getAttribute ||
        ['disabled', 'true', true].indexOf(element.getAttribute('disabled')) >=
            0
    ) {
        return false;
    }

    switch (element.nodeName) {
        case 'A':
            return (
                !!element.getAttribute('href') &&
                element.getAttribute('rel') !== 'ignore'
            );
        case 'INPUT':
            return (
                ['hidden', 'file'].indexOf(element.getAttribute('type')) <= 0
            );
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        default:
            return false;
    }
}



// WEBPACK FOOTER //
// ./src/utils/accessibility/isElementFocusable.ts